import React, { useState, useEffect, lazy, Suspense } from 'react';
import { InjectedIntlProps, injectIntl } from 'react-intl';
import ErrorBoundary from '../../../../errorHandling/errorBoundry';
import { MyContextProvider } from '../../../context/myContext';
import ".././main.css";
import { useDispatch, useSelector } from 'react-redux';
import { setIsBotError, getBotToken } from '../../../../core/store';
import { Tile } from '../Services/Tile';
import { lazyRetry } from '../../../utils/utils';
import { V2_Tile } from '../Services/V2components_Tile/V2_Tile';

const TicketDetailPage = lazy(() =>
  lazyRetry(() =>
    import('../ticketdetails/TicketDetailsRender').then(module => ({ default: module.TicketDetailPage }))
  )
);

const Workspace = lazy(() =>
  lazyRetry(() =>
    import('../Workspace/Workspace').then(module => ({ default: module.Workspace }))
  )
);
export interface MyWorkSpaceProp extends InjectedIntlProps {
  setActiveTabKey?: any;
  userId: any;
  isUserLoggedIn: any;
  isPageLoad: any;
  setRefreshHeaderTabCount: any;
  refreshHeaderTabCount: boolean;
}


const MainComponent: React.FC<MyWorkSpaceProp> = (props) => {
  const getToken = useSelector(getBotToken)
  const reduxDispatch = useDispatch();
  const [isTicketDetailVisible, setIsTicketDetailVisible] = useState(false);
  const [ticketStatus, setTicketStatus] = useState('All');

  useEffect(() => {
    if (getToken === null) {
      reduxDispatch(setIsBotError(true));
    }
    window.scrollTo(0, 0);
  }, []);


  const setActiveTabKeyinMain = (activeKey) => {
    props.setActiveTabKey(activeKey);
  }


  return (

    <div style={{ display: 'flex' }}>
      <div className='workspace'>
        <ErrorBoundary componentName="Workspace" >
          <MyContextProvider message={`workspace_${props.userId}`} >
            {!isTicketDetailVisible &&
              <Suspense
                fallback={
                  <>
                  </>
                }
              >
                <Workspace
                  isPageLoad={props.isPageLoad}
                  isUserLoggedIn={props.isUserLoggedIn}
                  setIsTicketDetailVisible={setIsTicketDetailVisible}
                  setTicketStatus={setTicketStatus}
                  setRefreshHeaderTabCount={props.setRefreshHeaderTabCount}
                  refreshHeaderTabCount={props.refreshHeaderTabCount}
                />
              </Suspense>
            }
          </MyContextProvider>
        </ErrorBoundary>
        <ErrorBoundary componentName="Services" >
          <MyContextProvider message={`tile_${props.userId}`}>
            {!isTicketDetailVisible &&
              <V2_Tile
                setActiveTabKey={setActiveTabKeyinMain}
                userId={props.userId}
                isUserLoggedIn={props.isUserLoggedIn}
                setRefreshHeaderTabCount={props.setRefreshHeaderTabCount}
                refreshHeaderTabCount={props.refreshHeaderTabCount}
              />
            }
          </MyContextProvider>
        </ErrorBoundary>

        <ErrorBoundary componentName="TicketDetails">
          <MyContextProvider message={`workspace_${props.userId}`}>
            {isTicketDetailVisible &&
              <Suspense
                fallback={
                  <>
                  </>
                }
              >
                <TicketDetailPage
                  setActiveTabKey={setActiveTabKeyinMain}
                  userId={props.userId}
                  isUserLoggedIn={props.isUserLoggedIn}
                  setIsTicketDetailVisible={setIsTicketDetailVisible}
                  status={ticketStatus}
                />
              </Suspense>
            }
          </MyContextProvider>
        </ErrorBoundary>

      </div>

      {/* Fake iris End */}
    </div>
  );
};
export const V2_Main = injectIntl(MainComponent);